export const ACTIVITY_MAP: any = {
    jp: 60,
};

export const CROWDFUNDING_END = {
    jp: new Date('2024/07/31 23:00:00 GMT+8').getTime(),
};
